import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faUser, faLock, faSignOutAlt, faCog, faDownload, faPlus, faFilm, faExclamation, faFileImage, faArrowsAlt, faPalette, faLayerGroup, faEye, faArrowLeft, faUserCircle, faChessKnight, faFileArchive, faHotel, faArrowsAltH, faIdCard, faArchive, faUserShield, faPenSquare, faBell, faCircleNotch, faLocationArrow, faClock, faCode
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub, faPaypal
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser, faLock, faSignOutAlt, faCog, faGithub, faDownload, faPlus, faFilm, faExclamation, faFileImage, faArrowsAlt, faPalette, faLayerGroup, faEye, faArrowLeft, faUserCircle, faChessKnight, faFileArchive, faHotel, faPaypal, faArrowsAltH, faIdCard, faArchive, faUserShield, faPenSquare, faBell, faCircleNotch, faLocationArrow, faClock, faCode
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/js/plugins/fontawesome.js